import React, { useState } from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import FunctionalCategories from './FunctionalCategories'
import { useNavigate } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faExclamationTriangle,
  faExclamationCircle,
  faPowerOff,
  faLayerGroup,
  faRandom,
  faAddressCard
} from '@fortawesome/free-solid-svg-icons'

function Stats({ employee, setActiveTab }) {
  const [functionalModalShow, setFunctionalModalShow] = useState(false)
  const navigate = useNavigate()

  const stats = [
    {
      name: 'Total Conflicts',
      icon: (
        <FontAwesomeIcon icon={faExclamationTriangle} className="text-danger" />
      ),
      value: employee?.conflicts_count,
      onClick: () => {
        setActiveTab('conflicts')
      }
    },
    {
      name: 'Roles',
      value: employee?.roles_count,
      icon: <FontAwesomeIcon icon={faAddressCard} className="text-primary" />,
      onClick: () => {
        setActiveTab('roles')
      }
    },
    {
      name: 'High Risk Permissions',
      value: employee?.high_risk_permissions_count,
      icon: (
        <FontAwesomeIcon icon={faExclamationCircle} className="text-warning" />
      ),
      onClick: () => {
        setActiveTab('permissions')
        navigate(`?is_high_risk=true`, { replace: true })
      }
    },
    {
      name: 'Super User Permissions',
      value: employee?.superuser_permissions_count,
      icon: <FontAwesomeIcon icon={faPowerOff} className="text-danger" />,
      onClick: () => {
        setActiveTab('permissions')
        navigate(`?is_super_user=true`, { replace: true })
      }
    },
    {
      name: 'Business Rules',
      icon: <FontAwesomeIcon icon={faLayerGroup} className="text-primary" />,
      value: employee?.business_rules_count,
      onClick: () => {
        setActiveTab('business-rules')
      }
    },
    {
      name: 'Functional Categories',
      icon: <FontAwesomeIcon icon={faRandom} className="text-primary" />,
      value: employee?.functional_categories_count,
      onClick: () => {
        setFunctionalModalShow(true)
      }
    }
  ]

  return (
    <>
      <style jsx>{`
        .stat-item:hover span {
          text-decoration: underline;
        }
      `}</style>
      <div>
        <FunctionalCategories
          employee={employee}
          show={functionalModalShow}
          setShow={setFunctionalModalShow}
          setActiveTab={setActiveTab}
        />
      </div>
      <Row>
        {stats.map((stat, index) => (
          <Col key={`${stat.name}-index`} sm={'auto'}>
            <div
              onClick={stat.onClick}
              style={{ cursor: 'pointer' }}
              className="stat-item"
            >
              <>
                {stat.icon}
                <span className="text-muted ms-1">{stat.value}</span>
                <span className="text-muted ms-1">{stat.name}</span>
              </>
            </div>
          </Col>
        ))}
      </Row>
    </>
  )
}

export default Stats
